// extracted by mini-css-extract-plugin
export default {"river":"river__1RItT"};